<template>
  <div id="main-content" style="background: #ffffff;">
    <div style="display: flex;padding: 10px;align-items: flex-end">
      <div style="font-size: 20px;">{{baseInfo.name}}</div>
      <div style="font-size:16px;margin: 0 5px;">（作者：{{baseInfo.group_name}}-{{baseInfo.user_name}}）</div>
      <a-tag>{{$store.state.report.panelType[baseInfo.type]}}</a-tag>
      <a-popconfirm
        v-if="baseInfo.user_id===$store.state.UserInfo.id"
        style="color: #cf1322;cursor: pointer"
        title="此操作会删除当前面板?"
        ok-text="删除"
        cancel-text="取消"
        @confirm="deletePanel(baseInfo.code)"
      >
        <a-icon style="font-size: 18px;" type="delete" />
      </a-popconfirm>
    </div>
    <div style="display: flex;align-items: flex-end;justify-content: space-between;padding: 10px;">
      <div>
        <a-range-picker v-model="filter.date"
                        v-if="this.baseInfo.condition.indexOf('date')!==-1"
                        valueFormat="YYYY-MM-DD"
                        style="width: 220px;margin: 5px 0px 5px 5px;" />
        <a-select v-model="filter[filterItem.code]" :placeholder="'请选择'+filterItem.name"
                  v-if="filterItem.code!=='date'"
                  :key="filterItem.code"
                  v-for="filterItem in this.baseInfo.condition_array"
                  allowClear mode="multiple" :maxTagCount="1" style="width: 220px;margin: 5px;">
          <a-select-option :value="filterItem.value"
                           :key="filterItem.value"
                           v-for="filterItem in filterData[filterItem.code]">
            {{filterItem.name}}
          </a-select-option>
        </a-select>
        <a-button type="primary" @click="initDataList">检索</a-button>
      </div>
      <div class="panel-table-tools">
        <div class="panel-table-tool-item" :class="showType==='table'?'active':''" @click="showType='table'"><a-icon type="table" /></div>
        <div class="panel-table-tool-item" :class="showType==='bar'?'active':''" @click="showType='bar'"><a-icon type="bar-chart" /></div>
        <div class="panel-table-tool-item" :class="showType==='line'?'active':''" @click="showType='line'"><a-icon type="line-chart" /></div>
        <div class="panel-table-tool-item" :class="showType==='pie'?'active':''" @click="showType='pie'"><a-icon type="pie-chart" /></div>
        <div class="panel-table-tool-item" @click="downLoad()"><a-icon type="download" />下载数据</div>
      </div>
    </div>
    <div style="padding: 10px;flex: 1;">
      <a-table v-if="showType==='table'"
        :columns="dataField" :data-source="Object.values(dataList)"
        :loading="dataLoad" bordered
        :scroll="{ y: '70vh', x :'100%' }" :pagination="false">

      </a-table>
      <div v-else style="text-align: center;font-size: 32px;margin-top: 10px;">
        功能待开发中！！！
      </div>
    </div>
  </div>
</template>

<script>
import {DeletePanel, GetAnalysis, GetAnalysisBase, GetPanel} from "../../api/v1/analysis";

export default {
  name: "Index",
  data(){
    return {
      filter:{
        app_id:0,
        date:['',''],
        country:[],
        spend_channel:[],
        revenue_channel:[],
        ad_type:[],
      },
      filterData:{
        country:this.$store.state.Country,
        spend_channel:this.$store.state.SpendChannel,
        revenue_channel:this.$store.state.RevenueChannel,
        ad_type:this.$store.state.AdType,
      },
      baseInfo:{
        condition:'',
        data_array:[],
        dimension_array:[],
      },
      dataField:[],
      dataList:{},
      dataLoad:false,
      showType:'table',
    }
  },
  watch:{
    getAppId:{
      handler(newName, oldName) {
        this.initDataList()
      },
      immediate: false,
      deep: true
    }
  },
  computed: {
    getAppId(){
      return this.$store.getters.getAppId
    },
  },
  mounted() {
    this.initPanel()
  },
  methods:{
    initPanel(){
      GetPanel({code:this.$route.query.code}).then(resp => {
        if (resp.code===200){
          this.baseInfo = resp.data
          this.initDataList()
        }else{
          this.$router.push({
            path:'/report',
            query:{app_id:this.$route.query.app_id}
          })
        }
      })
    },
    initDataList(){
      this.dataField = []
      this.dataList = {}
      this.dataLoad = true
      this.filter.app_id = this.getAppId
      this.baseInfo.dimension_array.forEach(item => {
        this.dataField.push({
          title: item.name,
          dataIndex: item.code,
          width: 150,
          fixed:'left'
        })
      })
      this.baseInfo.data_array.forEach(item => {
        this.dataField.push({
          title: item.name,
          dataIndex: item.code,
          width: 150
        })
        this.initDataBase(item.code)
      })
      // this.initDataAll()
    },
    initDataBase(code){
      GetAnalysisBase({
        filter:this.filter,
        dimension:this.baseInfo.dimension,
        data:code}
      ).then(resp => {
        if (resp.code===200){
          this.dataLoad = false
          this.filter = resp.data.filter
          resp.data.data.forEach(item=>{
            if (!this.dataList[item[this.baseInfo.dimension]])
              this.dataList[item[this.baseInfo.dimension]] = {key:Object.values(this.dataList).length}
            Object.assign(this.dataList[item[this.baseInfo.dimension]],item)
          })
        }
      })
    },
    initDataAll(){
      GetAnalysis({
        filter:this.filter,
        dimension:this.baseInfo.dimension,
        data:this.baseInfo.data}
      ).then(resp => {
        if (resp.code===200){
          this.dataList = resp.data.data
          this.filter = resp.data.filter
          this.dataLoad = false
        }
      })
    },
    deletePanel(code){
      DeletePanel({code:code}).then(resp => {
        if (resp.code===200){
          this.$message.success("删除成功")
          this.$router.push({
            path:'/report',
            query:{app_id:this.$route.query.app_id}
          })
        }
      })
    },
    downLoad(){
      let _name = this.$store.getters.getAppInfo.app_name+"【"+this.baseInfo.name+"】"
      _name += "截止："+this._get_current_date(2)+" 的"
      this.baseInfo.condition_array.forEach(c_i=>{
        _name += this.filter[c_i.code]
      })
      _name += "数据"
      this._export_cvs(Object.values(this.dataList),this.dataField,_name)
    }
  }
}
</script>

<style>
.panel-table-tools{
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  min-width: 200px;
  font-size: 16px;
}
.panel-table-tool-item{
  margin-right: 10px;
  user-select: none;
  cursor: pointer;
}
.panel-table-tool-item.active{
  color:#1890ff;
}
</style>



// WEBPACK FOOTER //
// src/views/Report/Index.vue